import { Grid, Group, NumberFormatter, Text, Title, useMantineTheme } from '@mantine/core';
import { IconCalendarDollar, IconClockDollar } from '@tabler/icons-react';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { Ticker } from 'components/Ticker';
import { i18nKeys, useTranslation } from 'locales/index';
import { BalanceInfoPanel } from './BalanceInfoPanel';
import { TurnoverInfoPanel } from './TurnoverInfoPanel';

export const DebtorTickersBanner = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const debtor = useDebtor();

  return (
    <Grid>
      <Grid.Col span={{ base: 6, md: 3 }}>
        <BalanceInfoPanel />
      </Grid.Col>
      <Grid.Col span={{ base: 6, md: 3 }}>
        <TurnoverInfoPanel />
      </Grid.Col>
      <Grid.Col span={{ base: 6, md: 3 }}>
        <Ticker
          title={t(
            i18nKeys.CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.AVERAGE_PAYMENT_DELAY,
          ).toUpperCase()}
          h="100%"
          topRight={<IconClockDollar size={18} color={theme.colors.gray[6]} />}
        >
          <Group mt="auto" align="end" gap="space2">
            <Title order={4}>
              <NumberFormatter decimalScale={2} value={debtor.average_payment_delay} />
            </Title>
            <Text>{t(i18nKeys.DAY)}</Text>
          </Group>
        </Ticker>
      </Grid.Col>
      <Grid.Col span={{ base: 6, md: 3 }}>
        <Ticker
          title={t(i18nKeys.CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.LATE_PAYMENT_RATE).toUpperCase()}
          h="100%"
          topRight={<IconCalendarDollar size={18} color={theme.colors.gray[6]} />}
        >
          <Group mt="auto" align="end" gap="space2">
            <Title order={4}>
              <NumberFormatter decimalScale={2} value={debtor.delay_rate} />
            </Title>
            <Text>%</Text>
          </Group>
        </Ticker>
      </Grid.Col>
    </Grid>
  );
};
